import React from 'react'
import {Popover} from '@material-ui/core'

// styles
import './PopAddViewOptions.scss'

const PopAddViewOptions = ({
  open,
  anchorEl,
  onClose,
  onClickAddChildView,
  onClickAddGroupView,
  views = [],
}) => {
  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      classes={{
        paper: 'c-add-view-options c-res-mod',
      }}
    >
      <button
        className="c-add-view-options__item ap-typography ap-typography--md"
        style={{width: 'auto', marginRight: 0}}
        onClick={onClickAddGroupView}
      >
        Add Group
      </button>
      <button
        className={`c-add-view-options__item ap-typography ap-typography--md ${
          views.length === 0 ? 'ap-disabled' : ''
        }`}
        style={{width: 'auto', marginRight: 0}}
        onClick={onClickAddChildView}
      >
        Add Filtered View
      </button>
    </Popover>
  )
}

export default PopAddViewOptions
